import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./TrianglePage.css";

const TrianglePage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Intro details array
  const introDetails = [
    {
      title: "Welcome to Acdcore Consulting",
          description: "Your one-stop destination for premium printing and branding solutions. We’re committed to delivering exceptional results that make your brand stand out.",
      image: "/images/bg44.png",
    },
    {
      title: "Exceptional Branding",
      description:
        "Stand out from the crowd with unique branding solutions tailored to your business. Let us make your brand unforgettable.",
      image: "/images/f4.png",
    },
    {
      title: "Innovative Designs",
      description:
        "Our creative designs ensure your business looks professional and modern. Let us help you create designs that leave a lasting impression.",
        image: "/images/lan1.png",
    },
  ];

  // Handle next and previous clicks
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % introDetails.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? introDetails.length - 1 : prevIndex - 1
    );
  };

  // Auto-scroll every 8 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 8000);

    // Cleanup on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="triangle-page">
      <h1 className="head">Welcome to Acdcore Consulting</h1>
      <button className="nav-button left" onClick={handlePrev}>
        <FaChevronLeft />
      </button>
      <div className="content-wrapper">
        <div className="details" data-aos="fade-left">
          <h1>{introDetails[currentIndex].title}</h1>
          <p>{introDetails[currentIndex].description}</p>
          <a href='https://wa.me/2348023879629' className="cta-button">Get Started</a>
        </div>
        <div className="image-container" data-aos="fade-right">
          <img src={introDetails[currentIndex].image} alt="Intro" />
        </div>
      </div>
      <button className="nav-button right" onClick={handleNext}>
        <FaChevronRight />
      </button>
    </div>
  );
};

export default TrianglePage;
